import _ from 'lodash'
import React from 'react'
import { Button, Dropdown, Menu, Popover, Checkbox, Row, Col, Input, Popconfirm, InputNumber } from 'antd'
import { app, use } from 'xadmin'
import { _t } from 'xadmin-i18n'
import { ModelBlock } from 'xadmin-model'
import { SettingOutlined, DragOutlined } from '@ant-design/icons';
import { findDOMNode } from 'react-dom'
import { DndProvider, DropTarget, DragSource } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import './index.css'
import { message } from 'antd'

const PageSizeButton = props => {
  const noModel = props?.noModel

  const { count } = noModel ? props?.count : use('model.count', props)
  const { size, setPageSize } = noModel ? props?.pagesize : use('model.pagesize', props)
  const [visible, setVisible] = React.useState(false)
  const [page, setPage] = React.useState(size)
  const input = React.createRef()

  const onSetPageSize = (size) => {
    setPageSize(size)
    setVisible(false)
  }

  const onInputSize = () => {
    let value = page || 1
    onSetPageSize(value)
  }

  const handleChange = e => {
    const value = e || 1
    setPage(value)
  }

  return (
    <span id='size-common'>
      <Popconfirm
        getPopupContainer={() => document.getElementById('size-common')}
        style={{ paddingLeft: 0 }}
        placement="bottom"
        trigger={['click']}
        icon={null}
        showCancel={false}
        onConfirm={onInputSize}
        okText={'确认'}
        title={
          <>
            <p>{'每页显示条数'}</p>
            <InputNumber style={{ width: 150 }} type="number" value={page} min={1} placeholder={'Customize page size'}
              ref={input} precision={0}
              onChange={handleChange}
            />
          </>
        }
      >
        <Button className="countButton" size='small' style={{ marginRight: '3px' }}>
          {'共'} {count} {'条 - 每页'} {size} {'条'}
        </Button>
      </Popconfirm>
    </span>
  )
}

const style = {
  width: 200,
  height: 50,
  lineHeight: '50px',
  background: 'pink',
  margin: '30px auto'
}
const types = {
  Card: 'card',
  Drag: 'drag'
}
@DragSource(types.Card, {
  beginDrag(props, monitor, component) {
    // 返回需要注入的属性
    return {
      id: props.id
    }
  },
  endDrag(props, monitor, component) {
    // 拖拽完成更新外部form
  }
}, (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
})
@DropTarget(types.Card, {
  drop(props, monitor, component) {
    //
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    if (dragIndex == hoverIndex) return

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

    const clientOffset = monitor.getClientOffset()

    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }
    props.moveCard(dragIndex, hoverIndex)
    monitor.getItem().index = hoverIndex
  },
  hover(props, monitor, component) {

    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    if (dragIndex == hoverIndex) return

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

    const clientOffset = monitor.getClientOffset()

    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }

    props.moveCard(dragIndex, hoverIndex)
    monitor.getItem().index = hoverIndex
  }
}, (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }
})
class ColsList extends React.Component {
  state = {
    current: null
  }
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      isDragging,
      children,
      index
    } = this.props

    return connectDragSource(
      connectDropTarget(
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }} {...this.props}>
          {children}
          {/* {
            index == this.state.current ? <DragOutlined style={{ width: '22px' }}/> : null
          } */}
        </div>
      )
    )
  }
}

const ColsDropdown = props => {
  const { selected, fields, changeFieldDisplay } = use('model.fields', props)
  const [colSelected, setColSelected] = React.useState(selected)
  const [currentIndex, setCurrentIndex] = React.useState()
  const { model } = use('model')
  const isHs = app.apps.find(item => item.name === 'iot-xj-hs')
  let items = []
  const showFields = Object.keys(fields).filter(name => fields[name].showInList !== false)
  const [fieldData, setFieldData] = React.useState([])
  let fieldArr = []
  let list = colSelected.filter(item => showFields.includes(item)) || []

  showFields.forEach(val => {
    let index = colSelected.findIndex(item => item == val)
    if (index == -1) { list = [...list, val] }
  })

  for (let [index, name] of list.entries()) {
    let field = fields[name]
      , fieldName = name
      , title = field?.title || name
      , fieldSelected = _.indexOf(colSelected, name) !== -1
    fieldArr.push([fieldName, fieldSelected])

    items.push(<Col span={24} style={{ margin: '5px 0', flex: 1 }} moveCard={moveCard} id={name} key={name} checked={fieldSelected}>
      <div className="popoverlabel">
        <Checkbox style={{ flex: 1 }} checked={fieldSelected} key={name} onChange={(e) => {
          // changeFieldDisplay([ fieldName, e.target.checked ]) 
          fieldArr.forEach((val, index) => {
            if (val[0] == fieldName) fieldArr[index] = [fieldName, e.target.checked]
          })
          if (colSelected?.length == 1 && fieldArr.filter(item => item[1]).map(item => item[0])?.length == 0) {
            message.info('至少需要选择一个配置项')
            fieldArr[index] = [fieldArr[index][0], true]
          } else {
            setColSelected(fieldArr.filter(item => item[1]).map(item => item[0]))
          }
        }}>
          {title}
        </Checkbox>
        <DragOutlined style={{ width: '20px' }} />
      </div>
    </Col>)
  }

  React.useEffect(() => {
    setColSelected(selected)
  }, [selected])

  let checked = items.filter(item => item?.props?.checked)
  React.useEffect(() => {
    let checked = items.filter(item => item?.props?.checked)
    let unchecked = items.filter(item => !item?.props?.checked)
    let newChecked = [...checked, ...unchecked]
    setFieldData(newChecked)
  }, [checked?.length])

  const moveCard = (dragIndex, hoverIndex) => {
    if (dragIndex != undefined && hoverIndex != undefined) {
      const refresh = fieldData.map(item => item)
      refresh[dragIndex] = fieldData[hoverIndex]
      refresh[hoverIndex] = fieldData[dragIndex]
      setFieldData(_.compact(refresh))
    }
  }

  const confirm = () => {
    let arr = fieldData.map(item => {
      return [item.key, item.props.checked]
    })
    changeFieldDisplay([], arr)
  }

  const cancel = () => {
    console.log('取消')
  }
  let newArr = []
  if (colSelected?.length && fields && Object.keys(fields)?.length)
    colSelected.forEach(val => {
      let index = Object.keys(fields).findIndex(item => item == val)
      if (index > -1) { newArr = [...newArr, colSelected[index]] }
    })
  return (
    <Popconfirm
      placement="bottomRight"
      icon={null}
      overlayStyle={{ width: 350 }}
      // getPopupContainer={() => document.getElementById('modelListMenu')}
      title={
        <>
          <Row>
            <Col span={12}>勾选您希望显示的字段</Col>
            <Col span={12} style={{ textAlign: 'right' }}>已选{newArr?.length}个字段</Col>
          </Row>
          <Row style={{ padding: '10px 0 4px', maxHeight: 300, overflowY: 'scroll' }}>
            <DndProvider backend={HTML5Backend} style={{ width: '100%' }}>
              {
                _.filter(fieldData, o => {
                  if (model.name == 'node' && !isHs) {
                    return o.key != 'status'
                  } else {
                    return true
                  }
                }).map((item, index) => {
                  return <ColsList {...props} key={item.key} index={index} id={item.key} children={item} moveCard={moveCard} />
                })
              }
            </DndProvider>
          </Row>
        </>
      }
      onConfirm={confirm}
      onCancel={cancel}
      okText="保存"
      cancelText="取消"
    >
      <Button type="default" className='ant-btn-text' style={{ marginLeft: '.5rem' }} icon={<SettingOutlined />}></Button>
    </Popconfirm>
  )
}

export default ({ children }) => (
  <div id="modelListMenu" className="modelListMenu">
    {/* <CountButton />{' '} */}
    <PageSizeButton />{' '}
    <ModelBlock name="model.list.submenu.btngroup" />
    <ColsDropdown />
    {children}
  </div>
)
